module.exports = __webpack_public_path__ + "img/pic_2.6d28db78.png";